import { useState, useEffect, useCallback } from 'react';
import { Tooltip } from 'antd';
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';

/** Matches tablet layout help FAB (touch target). */
export const TABLET_FLOATING_ACTION_PX = 48;

const FullscreenButton: React.FC = () => {
	const [isFullscreen, setIsFullscreen] = useState(
		!!document.fullscreenElement
	);

	useEffect(() => {
		const handler = () => setIsFullscreen(!!document.fullscreenElement);
		document.addEventListener('fullscreenchange', handler);
		return () => {
			document.removeEventListener('fullscreenchange', handler);
			if (document.fullscreenElement) document.exitFullscreen();
		};
	}, []);

	const toggle = useCallback(() => {
		if (document.fullscreenElement) {
			document.exitFullscreen();
		} else {
			document.documentElement.requestFullscreen();
		}
	}, []);

	return (
		<Tooltip
			title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
			placement="left"
		>
			<button
				type="button"
				onClick={toggle}
				style={{
					width: TABLET_FLOATING_ACTION_PX,
					height: TABLET_FLOATING_ACTION_PX,
					borderRadius: '50%',
					border: 'none',
					background: 'rgba(0, 0, 0, 0.55)',
					color: '#fff',
					fontSize: 22,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					cursor: 'pointer',
					boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
					transition: 'opacity 0.2s, background 0.2s',
					opacity: 0.6,
				}}
				onMouseEnter={(e) => {
					e.currentTarget.style.opacity = '1';
					e.currentTarget.style.background = 'rgba(0, 0, 0, 0.75)';
				}}
				onMouseLeave={(e) => {
					e.currentTarget.style.opacity = '0.6';
					e.currentTarget.style.background = 'rgba(0, 0, 0, 0.55)';
				}}
			>
				{isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
			</button>
		</Tooltip>
	);
};

export default FullscreenButton;
